import React, { useEffect, useState, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthPageLayout from "../../../../components/AuthPageLayout";
import OtpInput from "../../components/OtpInput";
import ButtonLoader from "../../../../../../components/ButtonLoader";
import Transition from "../../../../../../components/Transition";
import { RegisterUser } from "../../../../network/api/RegisterUser";
import "./success.css";
import { AnimatePresence } from "framer-motion";


export default function EmailVerification() {
    const { state } = useLocation(); // formData from Register


    const [otp, setOtp] = useState("");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();
    const { formData, realOtp } = state || {};
    const [success, setSuccess] = useState(false);

    const handleSubmit = useCallback(async (e) => {
        setIsLoading(true);
        e.preventDefault();
        setError("");

        if (otp.length !== 5) {
            setIsLoading(false);
            setError("Please enter a valid 5-digit OTP");
            return;
        }

        if (otp !== realOtp) {
            setIsLoading(false);
            setErrorMessage("Please enter a valid, OTP which is sent to your email")
            return;
        }

        //submit data here
        const response = await RegisterUser(formData);

        if (response.status === "success") {
            setIsLoading(false);
            setSuccess(true);

        } else {
            setIsLoading(false);
            setErrorMessage(response.message);
        }


    }, [formData, otp, realOtp, setError, setIsLoading, setErrorMessage, setSuccess]);

    useEffect(() => {
        setErrorMessage("");
        if (typeof formData === "undefined") {
            navigate("/register");
        }

        if (otp.length === 5) {
            handleSubmit({ preventDefault: () => { } });
        }

    }, [formData, otp, handleSubmit, setErrorMessage, navigate]);

    return (
        <AuthPageLayout>


            {!isLoading && !success ? (
                <>
                    <h4 className="text-center">
                        Verify Your Email
                    </h4>
                    <p className="text-center  text-dark mb-4">An OTP has been sent to your email <strong>{state?.email}</strong></p>

                    {!isLoading && errorMessage ? (
                        <AnimatePresence mode="wait">
                        <Transition key={errorMessage} >
                            <div className="alert alert-danger alert-dismissible alert-alt solid fade show">
                                <strong>Error!</strong> {errorMessage}
                            </div>
                        </Transition>
                        </AnimatePresence>
                    ) : null}
                    <form onSubmit={handleSubmit}>
                        <OtpInput length={5} onChange={(value) => setOtp(value)} isLoading={isLoading} />

                        {error && <div className="text-danger text-center mt-2">{error}</div>}

                        <div className="text-center mt-4">
                            <button type="submit" className="btn btn-primary btn-block" >
                                {isLoading ? <ButtonLoader /> : "Verify"}
                            </button>
                        </div>
                    </form>
                    <div className="new-account mt-3">
                        <p>Already have an account? <Link className="text-primary" to="/login">Sign in</Link></p>
                    </div>
                </>
            ) : (
                <>
                    <h4 className="text-center">
                        Email Verified Successfully
                    </h4>
                    <p className="text-center  text-dark mb-4">Your account has been registered. Choose the path that matches what you want to do next.</p>

                    <div className=" d-flex flex-column align-items-center justify-content-center text-center">
                        <svg
                            className="success-tick mb-4"
                            xmlns="http://www.w3.org/2000/svg"
                            width="100"
                            height="100"
                            viewBox="0 0 52 52"
                        >
                            <circle className="success-circle" cx="26" cy="26" r="25" fill="none" />
                            <path
                                className="success-check"
                                fill="none"
                                d="M14.1 27.2l7.1 7.2 16.7-16.8"
                            />
                        </svg>

                        <Link to="/welcome" className="btn btn-primary btn-block my-4" >
                            {isLoading ? <ButtonLoader /> : "Continue to Welcome"}
                        </Link>
                    </div>
                </>

            )}
        </AuthPageLayout>
    );
}
